import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as CarouselItemSelector } from './ItemSelector.vue';

export const carouselItemSelectorContainerStyles = cva(
	'flex h-[2px] max-w-[54.75px] md:max-w-[60px] cursor-pointer',
	{
		variants: {
			variant: {
				dark: 'bg-[hsla(var(--primary),0.2)] hover:bg-[hsla(var(--primary),0.4)]',
				white: 'bg-[hsla(var(--white),0.2)] hover:bg-[hsla(var(--white),0.4)]'
			},
			dynamicWidth: {
				true: 'w-full',
				false: 'w-[54.75px] md:w-[60px]'
			},
			size: {
				default: 'w-[54.75px] md:w-[60px]',
				sm: 'w-8 max-w-[36px] md:w-15 md:max-w-15'
			}
		},
		defaultVariants: {
			variant: 'white',
			size: 'default'
		}
	}
);

export const carouselItemSelectorBarStyles = cva('h-full w-full', {
	variants: {
		variant: {
			dark: 'bg-primary',
			white: 'bg-white'
		}
	},
	defaultVariants: {
		variant: 'white'
	}
});

export type CarouselGenericActionVariants = VariantProps<
	typeof carouselItemSelectorContainerStyles
>;

export type BaseProps = {
	class?: HTMLAttributes['class'];
	active: boolean;
	delay: number;
	variant?: CarouselGenericActionVariants['variant'];
};

export type WithSize = BaseProps & {
	size: CarouselGenericActionVariants['size'];
	dynamicWidth?: never;
};

export type WithDynamicWidth = BaseProps & {
	dynamicWidth: number;
	size?: never;
};

export type CarouselItemSelectorProps = WithSize | WithDynamicWidth;
